/**
 * ContractRepository
 *
 * Define os templates de contexto para eventos do domínio de contratos.
 */

const ContractRepository = {
  /**
   * Template para falha no export de contratos (POST /contract/export blob).
   * @param {{ filters?: object, dateRange?: object }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildExportContext(ctx = {}) {
    return {
      tags: { flow: 'contract_export', domain: 'contract' },
      extra: {
        filters: ctx.filters,
        date_range: ctx.dateRange,
      },
    };
  },

  /**
   * Template para erro silencioso de parse JSON no histórico do contrato.
   * @param {{ contractId?: number|string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildHistoryParseContext(ctx = {}) {
    return {
      tags: { flow: 'contract_history_parse', domain: 'contract' },
      extra: {
        contract_id: ctx.contractId,
      },
    };
  },
};

export default ContractRepository;
